// extracted by mini-css-extract-plugin
module.exports = {"applyTopNotice":"index-module_applyTopNotice_126yG"};